import script from "./CalendarEventWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./CalendarEventWidget.vue?vue&type=script&setup=true&lang=js"

import "./CalendarEventWidget.vue?vue&type=style&index=0&id=74a94568&lang=scss"

const __exports__ = script;

export default __exports__